import { loader as a } from "../spinner/Spinner.styles.es.js";
import { css as e } from "../stitches.config.es.js";
const i = {
  visibility: "hidden"
}, o = {
  background: "$coreGreys10",
  border: "solid 1px transparent",
  color: "$coreGreys50"
}, r = {
  background: "$lightBg100Main",
  border: "solid 1px $coreGreys20",
  color: "$coreGreys50"
}, t = e({
  [`&.${a}`]: {
    position: "absolute"
  },
  variants: {
    variant: {
      primary: {
        borderColor: "$lightBg100Main",
        borderTopColor: "$primary100main"
      },
      secondary: {
        borderColor: "$primary100main",
        borderTopColor: "$lightBg100Main"
      },
      tertiary: {
        borderColor: "$coreGreys70",
        borderTopColor: "$lightBg100Main"
      },
      tertiaryTransparent: {
        borderColor: "$coreGreys70",
        borderTopColor: "$lightBg100Main"
      },
      warning: {
        borderColor: "$lightBg100Main",
        borderTopColor: "$destructive100main"
      },
      warningOutline: {
        borderColor: "$destructive100main",
        borderTopColor: "$lightBg100Main"
      },
      function: {
        borderColor: "$coreGreys70",
        borderTopColor: "$lightBg100Main"
      },
      functionActive: {
        borderColor: "$primary200",
        borderTopColor: "$primary5"
      },
      success: {
        borderColor: "$lightBg100Main",
        borderTopColor: "$success100"
      },
      dark: {
        borderColor: "$lightBg100Main",
        borderTopColor: "$coreGreys100main"
      },
      highlight: {
        borderColor: "$lightBg100Main",
        borderTopColor: "$highlight100"
      }
    }
  }
}), n = {
  variant: {
    primary: {
      background: "$primary100main",
      color: "$lightBg100Main",
      "&:hover": {
        background: "$primary150"
      },
      "&:disabled": o
    },
    secondary: {
      background: "$lightBg100Main",
      borderColor: "$primary100main",
      color: "$primary100main",
      "&:hover": {
        background: "$coreGreys5",
        color: "$primary150",
        borderColor: "$primary150"
      },
      "&:disabled": r
    },
    tertiary: {
      background: "$lightBg100Main",
      borderColor: "$coreGreys50",
      color: "$coreGreys100main",
      "&:hover": {
        background: "$coreGreys5"
      },
      "&:disabled": r
    },
    tertiaryTransparent: {
      background: "$lightBg100Main",
      borderColor: "$coreGreys50",
      color: "$coreGreys100main",
      "&:hover": {
        background: "$darkBg10"
      },
      "&:disabled": r
    },
    warning: {
      background: "$destructive100main",
      color: "$lightBg100Main",
      "&:hover": {
        background: "$destructive150"
      },
      "&:disabled": o
    },
    warningOutline: {
      background: "$lightBg100Main",
      borderColor: "$destructive100main",
      color: "$destructive100main",
      "&:hover": {
        background: "$coreGreys5",
        color: "$destructive200",
        borderColor: "$destructive200"
      },
      "&:disabled": r
    },
    function: {
      background: "$lightBg100Main",
      borderColor: "$coreGreys20",
      color: "$coreGreys100main",
      "&:hover": {
        background: "$coreGreys5"
      },
      "&:disabled": r
    },
    functionActive: {
      background: "$primary5",
      borderColor: "$primary30",
      color: "$primary150",
      "&:hover": {
        background: "$primary20",
        color: "$primary200"
      },
      "&:disabled": r
    },
    success: {
      background: "$success100",
      color: "$lightBg100Main",
      "&:hover": {
        background: "$success150"
      },
      "&:disabled": o
    },
    dark: {
      background: "$coreGreys100main",
      color: "$lightBg100Main",
      "&:hover": {
        background: "$coreGreys70"
      },
      "&:disabled": o
    },
    highlight: {
      background: "$highlight100",
      color: "$lightBg100Main",
      "&:hover": {
        background: "$highlight200"
      },
      "&:disabled": o
    }
  },
  borderRadius: {
    none: {
      borderRadius: "$none"
    },
    xsmall: {
      borderRadius: "$xs"
    },
    small: {
      borderRadius: "$sm"
    },
    medium: {
      borderRadius: "$md"
    },
    large: {
      borderRadius: "$lg"
    },
    xlarge: {
      borderRadius: "$xl"
    },
    circle: {
      borderRadius: "$circle"
    }
  },
  event: {
    true: {
      pointerEvents: "none"
    }
  },
  loader: {
    true: {
      borderColor: "$coreGreys70"
    }
  },
  size: {
    small: {
      padding: "0.4375rem 1rem"
    },
    normal: {
      padding: "0.5625rem 1rem"
    },
    large: {
      padding: "0.5625rem 1rem"
    },
    xlarge: {
      padding: "0.59375rem 1.25rem"
    }
  }
}, s = e({
  flexCenter: !0,
  position: "relative",
  border: "1px solid transparent",
  variants: n,
  "&:not(:disabled)": {
    cursor: "pointer"
  }
}), c = e({
  width: "1rem",
  height: "1rem",
  variants: {
    position: {
      start: {
        marginRight: "0.75rem"
      },
      end: {
        marginLeft: "0.75rem"
      }
    },
    invisible: {
      true: i
    }
  }
}), g = e({
  defaultVariants: {
    unstyled: !1
  },
  variants: {
    unstyled: {
      false: {
        lineHeight: "$6",
        fontWeight: "$medium",
        fontFamily: "$default"
      }
    },
    invisible: {
      true: i
    },
    size: {
      small: {
        fontSize: "$small"
      },
      normal: {
        fontSize: "$semiMedium"
      },
      large: {
        fontSize: "$medium"
      },
      xlarge: {
        fontSize: "$medium",
        fontWeight: "$bold"
      }
    }
  }
}), b = e({
  cursor: "pointer",
  border: 0,
  padding: 0,
  appearance: "none",
  fontSize: "$medium",
  backgroundColor: "transparent",
  textAlign: "left",
  color: "$primary100main",
  textDecoration: "none",
  boxSizing: "border-box"
});
export {
  n as buttonVariants,
  c as iconStyles,
  g as labelStyles,
  t as loaderStyles,
  s as rootStyles,
  b as unstyledButtonStyles
};
//# sourceMappingURL=Button.styles.es.js.map
